export const specialties = [
    {name:'Medicina General',id:'0'},
    {name:'Pediatria',id:'1'},
    {name:'Ginecología/Obstetricia',id:'2'}
    ];


// WEBPACK FOOTER //
// ./src/app/users/specialties.component.ts